import { useMutation } from "@tanstack/react-query";
import { getChatApiClient } from "@shared/apis/sidekick/api-factories";

type UseBeginChatProps = {
  onSuccess(data: { thread: string }): void;
};

type Params = {
  firstMessage?: string;
  metadata?: Record<string, string>;
};

export const useBeginChat = (props: UseBeginChatProps) => {
  const { onSuccess } = props;
  const chatApi = getChatApiClient();
  const mutation = useMutation({
    mutationFn: async ({ firstMessage, metadata }: Params) => {
      const response = await chatApi.chatControllerBeginNewChatAndRenameWithAI({
        beginChatRequest: {
          firstMessage,
          metadata,
        },
      });
      onSuccess(response);
      return response;
    },
    onError: (error) => {
      console.error("Failed to start a new chat", error);
    },
    mutationKey: ["begin-new-chat"],
  });

  return mutation;
};
